<template>
  <!-- z-index 300 to cater for safari bug -->
  <v-autocomplete
    :label="label"
    v-model="selected"
    @input="handleInput"
    @change="handleInput"
    @focus="immediate && search()"
    :color="themes.candidate.light.input"
    :disabled="disabled"
    :hint="hint"
    :items="options"
    :loading="loading"
    :placeholder="searchTerm"
    :required="required"
    :rules="rules || []"
    :search-input.sync="searchTerm"
    item-value="id"
    :style="toFront ? 'z-index: 301' : ''"
    return-object
    hide-no-data
    no-filter
    clearable
    attach
  >
    <template slot="item" slot-scope="{ item: institution }">
      <v-list-tile-avatar>
        <img :src="institution.logo || '/img/missing/logos/institutions/original.png'" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ institution.name }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="institution.former_names && institution.former_names.length">
          formerly {{ institution.former_names.join(', ') }}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title v-else-if="institution.acronym">
          {{ institution.acronym }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="selection" slot-scope="{ item: institution }">
      <v-chip v-if="institution.name">
        <v-avatar v-if="institution.logo">
          <img :src="institution.logo" />
        </v-avatar>
        {{ institution.name }}
      </v-chip>
    </template>
    <template slot="append-item">
      <v-btn
        @click="sendCrispMessage('I would like to add a qualification to your database')"
        :color="themes.candidate.light.primaryActionButton"
      >
        <v-icon left>mdi-help-circle</v-icon>
        Help, I cannot find my qualification
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    disabled: Boolean,
    hint: { type: String, default: () => 'Start typing institution or school name' },
    label: { type: String, default: () => 'School or institution' },
    required: Boolean,
    rules: Array,
    toFront: { type: Boolean, default: () => true },
    immediate: { type: Boolean, default: () => false },
    value: [Object, Number],
  },

  created() {
    this.setSelected()
  },

  data() {
    return {
      selected: {},
      loading: false,
      searchTerm: '',
      institutions: [],
    }
  },

  computed: {
    options() {
      if (this.selected && this.selected.id) return [this.selected, ...this.institutions]
      return this.institutions.length ? this.institutions : []
    },
  },

  watch: {
    value: function() {
      this.setSelected()
    },

    searchTerm: _.debounce(function(search) {
      this.$emit('search', search)
      // search is null on initial load
      if (search && search.length > 0) {
        this.search()
      } else {
        this.institutions = []
      }
    }, 300),
  },

  methods: {
    handleInput(institution) {
      this.selected = _.get(institution, 'id') ? institution : {}
      this.$emit('input', this.selected)
    },

    search() {
      this.loading = true
      let params = { search: this.searchTerm }

      this.$http
        .get('search/institutions', { params })
        .then(response => {
          this.institutions = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => (this.loading = false))
    },

    sendCrispMessage(message) {
      if (!window.CRISP_READY || !message || !message.length) return
      $crisp.push(["do", "chat:open"])
      $crisp.push(["do", "message:send", ["text", message]])
    },

    setSelected() {
      if (_.get(this.value, 'name')) {
        this.searchTerm = this.value.name
        this.selected = JSON.parse(JSON.stringify(this.value))
        this.search()
      }
    },
  },
}
</script>
